import type { Config, DefaultRootProps } from '@measured/puck';
import blocks from '@admin/config/blocks/index';
import root from '@admin/root';
import categories from '@admin/config/categories';

export const config: (
  rootProps?: any,
  liveMode?: boolean
) => Config<Record<string, any>, DefaultRootProps, string> = (
  rootProps,
  liveMode
) => ({
  components: blocks as any,
  root: root(rootProps, liveMode) as any,
  categories,
});

export default config;
